module.exports = __webpack_public_path__ + "static/media/articles3.3fdef477.png";